<!--begin::Main-->
<ngx-spinner class="custom-spinner"
*ngIf="isLoadSpinner"
bdColor="rgba(255,255,255,1)"
  size="medium"
  color="#fff"
  type="ball-atom"
  [fullScreen]="true"
>
<span class="loader">
  <img width="150px"  src="/assets/media/logos/logo-wegestu-color.png" alt="">
</span>
</ngx-spinner>
<div class="app-main flex-column flex-row-fluid" id="kt_app_main">
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <!--begin::Page title-->
        <div
          class="page-title d-flex flex-column justify-content-center flex-wrap me-3"
        >
          <!--begin::Title-->
          <div class="masse d-flex align-items-center">
            <h1 class="page-heading">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="35"
                height="37"
                viewBox="0 0 35 37"
                fill="none"
              >
                <g filter="url(#filter0_d_859_3381)">
                  <path
                    d="M21.3577 10.6574C21.3577 10.9957 21.3095 11.3532 21.2227 11.7301C20.972 12.7641 20.3935 13.8754 19.5738 14.6195C19.5545 14.6388 19.5353 14.6678 19.5063 14.6774C18.9374 15.1703 18.2624 15.4892 17.5006 15.4892C16.7389 15.4892 16.0639 15.1703 15.495 14.6774C15.466 14.6678 15.4467 14.6388 15.4275 14.6195C14.6078 13.8754 14.0293 12.7641 13.7786 11.7301C13.6918 11.3532 13.6436 10.9957 13.6436 10.6574C13.6436 8.52181 15.3696 6.79205 17.5006 6.79205C19.6317 6.79205 21.3577 8.52181 21.3577 10.6574Z"
                    fill="#265D91"
                  />
                  <path
                    d="M23.2861 21.2872V26.119C23.2861 27.1819 22.4183 28.0516 21.3576 28.0516H13.6434C12.5827 28.0516 11.7148 27.1819 11.7148 26.119V21.2872C11.7148 19.1613 13.0841 17.3542 14.9934 16.7068C15.1862 16.6488 15.3791 16.5908 15.5719 16.5521C15.8805 16.4845 16.2083 16.4555 16.5362 16.4555H18.4647C18.7926 16.4555 19.1204 16.4845 19.429 16.5521C19.6219 16.5908 19.8147 16.6488 20.0076 16.7068C21.9168 17.3542 23.2861 19.1613 23.2861 21.2872Z"
                    fill="#265D91"
                  />
                  <path
                    d="M29.0707 4.85934C29.0707 6.78237 27.5279 9.69106 25.2137 9.69106C24.3072 9.69106 23.5165 9.24655 22.8994 8.58943C22.639 7.89366 22.2533 7.2752 21.7519 6.74371C21.5012 6.09626 21.3662 5.43915 21.3662 4.85934C21.3662 2.72372 23.0923 0.993958 25.2233 0.993958C27.3543 0.993958 29.0804 2.72372 29.0804 4.85934H29.0707Z"
                    fill="#265D91"
                  />
                  <path
                    d="M30.9992 15.4891V20.3209C30.9992 21.3838 30.1313 22.2536 29.0706 22.2536H25.2136V21.2872C25.2136 18.6877 23.7382 16.4265 21.5879 15.2959C22.6582 13.9623 23.2561 12.2132 23.2754 10.754C23.5936 10.6961 23.9214 10.6574 24.2493 10.6574H26.1778C28.8392 10.6574 30.9992 12.822 30.9992 15.4891Z"
                    fill="#265D91"
                  />
                  <path
                    d="M13.642 4.85934C13.642 5.43915 13.507 6.09626 13.2563 6.73405C12.7549 7.2752 12.3692 7.89366 12.1088 8.58943C11.4917 9.24655 10.701 9.69106 9.79459 9.69106C7.48033 9.69106 5.9375 6.78237 5.9375 4.85934C5.9375 2.72372 7.66355 0.993958 9.79459 0.993958C11.9256 0.993958 13.6517 2.72372 13.6517 4.85934H13.642Z"
                    fill="#265D91"
                  />
                  <path
                    d="M11.7238 10.754C11.7431 12.2132 12.341 13.9623 13.4113 15.2959C11.261 16.4265 9.78563 18.6877 9.78563 21.2872V22.2536H5.92854C4.86784 22.2536 4 21.3838 4 20.3209V15.4891C4 12.822 6.15997 10.6574 8.82136 10.6574H10.7499C11.0778 10.6574 11.4056 10.6961 11.7238 10.754Z"
                    fill="#265D91"
                  />
                </g>
                <defs>
                  <filter
                    id="filter0_d_859_3381"
                    x="0"
                    y="0.993958"
                    width="34.999"
                    height="35.0577"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_859_3381"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_859_3381"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
              Nos consultants externes
            </h1>
            <div class="tools">
              <div class="dropdown">
                <button
                  class="masse-btn dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <svg
                    width="42"
                    height="42"
                    viewBox="0 0 42 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_d_588_1703)">
                      <circle cx="20" cy="18" r="13" fill="white" />
                    </g>
                    <path
                      d="M19.6667 13V23"
                      stroke="#265D91"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <path
                      d="M15 18.3333H25"
                      stroke="#265D91"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                    <defs>
                      <filter
                        id="filter0_d_588_1703"
                        x="0"
                        y="0"
                        width="42"
                        height="42"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dx="1" dy="3" />
                        <feGaussianBlur stdDeviation="4" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_588_1703"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_588_1703"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <a
                    class="dropdown-item cursor-pointer"
                    (click)="openModaladd(add_consultant)"
                    >Ajout unitaire</a
                  >
                  <a class="dropdown-item" (click)="downloadCsv()"
                    >Télécharger un modèle d'ajout en masse</a
                  >
                  <a class="dropdown-item" (click)="openModalBulk(add_masse)"
                    >Ajout en masse</a
                  >
                </div>
              </div>
            </div>
            <!--begin::Menu-->
          </div>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul
            class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1"
          >
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a routerLink="/accueil" class="text-muted">Accueil</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">Nos consultants externes</li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->

        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <!--begin::Content container-->
      <div
        id="kt_app_content_container"
        class="app-container container-fluid mb-15"
      >
        <!--begin::Card-->
        <div class="card">
          <!--begin::Card header-->

          <div
            class="card-body"
            [formGroup]="searchForm"
          >
            <div class="title mb-10">
              <h4>Recherche</h4>
            </div>
            <div class="row mb-5">
              <div class="col-lg-6">
                <div class="input-group search-libre">
                  <span class="input-group-text" >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                        fill="#7E7C7C"
                      />
                    </svg>
                  </span>

                  <input
                    type="text"
                    data-kt-customer-table-filter="search"
                    class="form-control ps-5"
                    placeholder="Rechercher"
                    formControlName="search" (keyup.enter)="searchconsultantexterne()"
                  />
                  <div class="tooltip-container tooltip-info">
                    <div class="tooltip-trigger">
                      <i
                        class="fa-solid fa-circle-info"
                        style="font-size: 20px"
                      ></i>
                    </div>
                    <div class="tooltip-content">
                      <div class="content">
                        <h4>Opérateur AND :</h4>
                        <p>
                          Utilisez l'opérateur AND pour spécifier que les
                          résultats doivent inclure plusieurs termes.
                        </p>
                        <p>
                          Exemple : software AND engineer renverra des profils
                          qui mentionnent à la fois "software" et "engineer".
                        </p>
                        <h4>Opérateur OR :</h4>
                        <p>
                          Utilisez l'opérateur OR pour spécifier que les
                          résultats peuvent inclure l'un des termes.
                        </p>
                        <p>
                          Exemple : sales OR marketing renverra des profils qui
                          mentionnent soit "sales" soit "marketing".
                        </p>
                        <h4>Opérateur NOT :</h4>
                        <p>
                          Utilisez l'opérateur NOT pour exclure des termes
                          spécifiques des résultats.
                        </p>
                        <p>
                          Exemple : developer NOT manager renverra des profils
                          qui mentionnent "developer" mais pas "manager".
                        </p>
                        <h4>Guillemets pour une expression exacte :</h4>
                        <p>
                          Utilisez des guillemets pour rechercher une expression
                          exacte.
                        </p>
                        <p>
                          Exemple : "product manager" renverra des profils qui
                          mentionnent exactement "product manager".
                        </p>
                        <h4>Parenthèses pour grouper des opérations :</h4>
                        <p>
                          Utilisez des parenthèses pour définir l'ordre
                          d'évaluation des opérations.
                        </p>
                        <p>
                          Exemple : (sales OR marketing) AND manager renverra
                          des profils qui mentionnent "sales" ou "marketing" et
                          "manager".
                        </p>
                        <h4>Recherche standard :</h4>
                        <p>
                          Si aucun opérateur n'est spécifié dans la recherche,
                          le texte sera interprété comme s'il était entre
                          guillemets.
                        </p>
                        <p>
                          Exemple : La recherche product manager sera traitée
                          comme "product manager", suivant la règle 4.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tools">
              <div class="row">
                <div class="col-lg-3">
                  <input
                    type="text"
                    formControlName="name"
                    name="nom_consultant"
                    id="nom_consultant"
                    class="form-control form-control-solid mb-3"
                    placeholder="Nom et prénom"
                  />
                </div>
                <div class="col-lg-3">
                  <input
                    type="text"
                    formControlName="esn_name"
                    name="nom"
                    id="nom"
                    class="form-control form-control-solid mb-3"
                    placeholder="ESN"
                  />
                </div>
                <div class="col-lg-3">
                  <input
                    type="text"
                    formControlName="poste"
                    name="nom"
                    id="nom"
                    class="form-control form-control-solid mb-3"
                    placeholder="Poste"
                  />
                </div>
                <div class="col-lg-3">
                  <ng-select
                    [bindValue]="'id'"
                    [items]="listProjects"
                    formControlName="project_id"
                    class="mb-3"
                    [bindLabel]="'name'"
                    id="compt"
                    placeholder="Projet"
                    [notFoundText]="'Aucun élément trouvé'"
                  >
                  </ng-select>
                </div>
              </div>

              <div class="row" *ngIf="!isCollapsed">
                <div class="col-lg-3">
                  <ng-select
                    [items]="skillsList"
                    formControlName="skillsOr"
                    class="mb-3"
                    bindLabel="name_FR"
                    bindValue="name_FR"
                    [multiple]="true"
                    [placeholder]="'Compétences (ou)'"
                    [notFoundText]="'Aucun élément trouvé'"
                    autoComplete
                  >
                  </ng-select>
                </div>
                <div class="col-lg-3">
                  <ng-select
                    [items]="skillsList"
                    formControlName="skillsAnd"
                    class="mb-3"
                    [multiple]="true"
                    id="compt"
                    bindValue="name_FR"
                    placeholder="Compétences (et)"
                    bindLabel="name_FR"
                    [notFoundText]="'Aucun élément trouvé'"
                  >
                  </ng-select>
                </div>
                <div class="col-lg-3">
                  <input
                    type="text"
                    id="statut"
                    class="form-control form-control-solid mb-3"
                    placeholder="Expérience min"
                    formControlName="min_experience_years"
                    oninput="validity.valid||(value='0');"
                    min="0"
                  />
                </div>
                <div class="col-lg-3">
                  <input
                    type="text"
                    id="statut"
                    class="form-control form-control-solid mb-3"
                    placeholder="Expérience max"
                    formControlName="max_experience_years"
                    oninput="validity.valid||(value='0');"
                    min="0"
                  />
                </div>
              </div>
              <div class="row" *ngIf="!isCollapsed">
                <div class="col-lg-3">
                  <div class="combined-input mb-3">
                    <input
                      type="number"
                      oninput="validity.valid||(value='0');"
                      min="0"
                      formControlName="tjm_achat"
                      class="nb1"
                      placeholder="TJM (achat)"
                      id="tjm"
                    />
                    <div class="euro">
                      <svg
                        width="11"
                        height="11"
                        viewBox="0 0 11 11"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M5.889 8.739C6.435 8.739 6.91167 8.62633 7.319 8.401C7.735 8.167 8.06 7.82467 8.294 7.374H10.075C9.737 8.24067 9.19533 8.908 8.45 9.376C7.70467 9.844 6.851 10.078 5.889 10.078C4.875 10.078 3.97367 9.805 3.185 9.259C2.39633 8.70433 1.846 7.96767 1.534 7.049H0.338V6.035H1.3C1.28267 5.79233 1.274 5.60167 1.274 5.463C1.274 5.32433 1.28267 5.13367 1.3 4.891H0.338V3.877H1.534C1.846 2.95833 2.39633 2.226 3.185 1.68C3.97367 1.12533 4.875 0.847999 5.889 0.847999C6.84233 0.847999 7.69167 1.08633 8.437 1.563C9.191 2.031 9.737 2.69833 10.075 3.565H8.294C8.06 3.11433 7.735 2.77633 7.319 2.551C6.91167 2.317 6.435 2.2 5.889 2.2C5.25633 2.2 4.69733 2.34733 4.212 2.642C3.73533 2.93667 3.37133 3.34833 3.12 3.877H5.889V4.891H2.834C2.808 5.073 2.795 5.26367 2.795 5.463C2.795 5.66233 2.808 5.853 2.834 6.035H5.889V7.049H3.12C3.37133 7.58633 3.73533 8.00233 4.212 8.297C4.69733 8.59167 5.25633 8.739 5.889 8.739Z"
                          fill="#4B4B4B"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="col-lg-3">
                  <ng-select
                    (change)="onCountryChange('add')"
                    class="mb-3"
                    [multiple]="true"
                    [notFoundText]="'Aucun élément trouvé'"
                    [items]="paysList"
                    bindLabel="name"
                    formControlName="pays"
                    bindValue="name"
                    [placeholder]="'Pays'"
                    autoComplete
                  >
                  </ng-select>
                </div>
                <div class="col-lg-3">
                  <ng-select
                    formControlName="mobility"
                    class="mb-3"
                    [multiple]="true"
                    (change)="onMobilityChange('add')"
                    [items]="stateList"
                    [ngClass]="{'disable-select':!stateList?.length}" [attr.disabled]="!stateList?.length ? true : null"
                    bindLabel="name"
                    bindValue="name"
                    [placeholder]="'Mobilité'"
                    [multiple]="true"
                    autoComplete
                    [notFoundText]="'Aucun élément trouvé'"
                  >
                  </ng-select>
                </div>
              </div>
              <div class="row mb-3 mb-0-sm">
                <div class="col-lg-3 mb-3"></div>
                <div class="col-lg-3 mb-3"></div>
                <div class="col-lg-3 mb-3"></div>
                <div class="col-lg-3 mb-3 seemore">
                  <a
                    [ngClass]="{
                      'show-more-button': !isCollapsed,
                      'emphasized-button': isCollapsed
                    }"
                    (click)="toggleCollapsible()"
                    class="show-more-button"
                  >
                    {{
                      isCollapsed
                        ? "Voir plus de critères de recherche"
                        : "Voir moins"
                    }}
                  </a>
                </div>
              </div>
              <div class="search-btn-wrapper mb-3">
                <div class="rechercher">
                  <div class="mb-3 search-btn d-flex justify-content-end">
                    <div class="align-items-center">
                      <button
                        type="button"
                        class="me-5"
                        (click)="searchconsultantexterne()"
                      >
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 20 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.7235 18.263L16.0223 14.5657C18.8541 11.0421 18.5809 5.83122 15.3515 2.63023C13.6625 0.942973 11.4019 0 8.9923 0C6.58271 0 4.34709 0.942973 2.63307 2.63023C0.943993 4.31749 0 6.5756 0 8.98259C0 11.3895 0.943993 13.6228 2.63307 15.3349C4.32216 17.0222 6.58271 17.9652 8.9923 17.9652C11.0293 17.9652 13.0165 17.2704 14.6063 16.005L18.3076 19.7023C18.5064 19.9008 18.7547 20 19.0032 20C19.2764 20 19.5249 19.9008 19.6987 19.7023C20.0962 19.2805 20.0962 18.6601 19.7235 18.2631L19.7235 18.263ZM15.9973 8.95782C15.9973 10.8189 15.2771 12.5807 13.9603 13.8958C12.6438 15.2109 10.88 15.9306 9.01701 15.9306C7.154 15.9306 5.39017 15.2111 4.0737 13.8958C2.75714 12.5806 2.03667 10.8188 2.03667 8.95782C2.03667 7.09682 2.75697 5.3349 4.0737 4.01985C5.39026 2.70472 7.154 1.98502 9.01701 1.98502C10.88 1.98502 12.6438 2.70454 13.9603 4.01985C15.2771 5.33499 15.9973 7.09682 15.9973 8.95782Z"
                            fill="white"
                          />
                        </svg>
                        Rechercher
                      </button>
                    </div>
                    <div class="resett-btn">
                      <div
                        class="reset-icon cursor-pointer"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Réinitialiser"
                      >
                        <a (click)="reset()">
                          <img
                            src="/assets/media/icons/reset.png"
                            alt=""
                            width="30px"
                        /></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Content container-->
      </div>

      <!--begin::Content container-->
      <div *ngIf="!isLoadSpinner" id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Card-->
        <div class="card pb-10">
          <!--begin::Card header-->
          <div class="toolbar">
            <div class="section_title">
              <h1 class="section-heading my-0">
                Liste des consultants externes
              </h1>
            </div>
            <div class="filter-tools mt-10 mb-10">
              <ul class="nav nav-pills me-5">
                <li class="nav-item m-0">
                  <a
                    class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary me-3"
                    data-bs-toggle="tab"
                    href="#kt_project_targets_card_pane"
                  >
                    <i class="ki-duotone ki-element-plus fs-1">
                      <span class="path1"></span>
                      <span class="path2"></span>
                      <span class="path3"></span>
                      <span class="path4"></span>
                      <span class="path5"></span>
                    </i>
                  </a>
                </li>
                <li class="nav-item m-0">
                  <a
                    class="btn btn-sm btn-icon btn-light btn-color-muted btn-active-primary active"
                    data-bs-toggle="tab"
                    href="#kt_project_targets_table_pane"
                  >
                    <i class="ki-duotone ki-row-horizontal fs-2">
                      <span class="path1"></span>
                      <span class="path2"></span>
                    </i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="toolbar"></div>

          <!--end::Card header-->
          <!--begin::Card body-->
          <div class="card-body pt-0">
            <div class="tab-content for-web">
              <!--begin::Tab pane-->
              <div id="kt_project_targets_card_pane" class="tab-pane fade">
                <!--begin::Row-->
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div
                    class="col-md-6 col-xxl-4"
                    *ngFor="let s of listconsulatant"
                  >
                    <!--begin::Card-->
                    <div class="card pt-5 p-5">
                      <div class="tools">
                        <div class="dropdown">
                          <button
                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <svg
                              width="19"
                              height="5"
                              viewBox="0 0 19 5"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 0 4.89478)"
                                fill="#265D91"
                              />
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                fill="#265D91"
                              />
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                fill="#265D91"
                              />
                            </svg>
                          </button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <a
                              class="dropdown-item"
                              [routerLink]="[
                              '/candidats/profilecandidatesn',
                              s.id
                            ]"
                              style="cursor: pointer"
                              >Voir Détail</a
                            >

                            <a
                              class="dropdown-item"
                              (click)="openModal(modifier_consultant, s)"
                              style="cursor: pointer"
                            >
                              Modifier
                            </a>
                            <a
                            class="dropdown-item cursor-pointer"
                            (click)="
                              dissocierconsultant(s.id)
                            "
                            >Dissocier consultant</a
                          >
                          </div>
                        </div>
                      </div>
                      <!--begin::Card body-->

                      <div class="card-body d-flex flex-center flex-column">
                        <div class="symbol symbol-65px symbol-circle mb-5">
                          <!-- <img src="assets/media//avatars/300-2.jpg" alt="image" /> -->
                          <img
                            *ngIf="s.image_url && s.image_url != 'avatar.png'"
                            class="table-img circle-img"
                            src="{{ urlimage + s.image_url }}"
                            alt=""
                            width="50px"
                          />
                          <img
                            *ngIf="s.image_url && s.image_url == 'avatar.png'"
                            class="table-img circle-img"
                            src="{{
                              url + '/Company/file/gallery_company/avatar.png'
                            }}"
                            alt=""
                            width="50px"
                          />
                          <img
                            *ngIf="!s.image_url || s.image_url === 'undefined'"
                            class="table-img circle-img"
                            src="{{
                              url + '/Company/file/gallery_company/avatar.png'
                            }}"
                            alt=""
                            width="50px"
                          />

                         
                        </div>
                        <!--end::Avatar-->
                        <!--begin::Name-->
                        <a class="fs-4 text-gray-800 fw-bold mb-0"> {{ s.first_name }} {{ s.last_name }} 
                        </a>

                        <div class="content-card">
                          <!--begin::Stats-->
                          <div class="info">
                            <div class="py-3 px-4">
                              <div class="badge-annee">
                                <span>Date :</span>
                                {{
                                  s.consultant_client_finals_date_first_service
                                    ? s.consultant_client_finals_date_first_service
                                    : "---"
                                }}
                              </div>
                            </div>
                          </div>

                          <!--end::Stats-->
                          <!--begin::Stats-->

                          <!--end::Stats-->
                        </div>

                        <!--end::Info-->
                      </div>
                      <div class="foot p-5">
                        <div class="plus">
                          <a
                            style="cursor: pointer"
                            [routerLink]="[
                              '/candidats/profilecandidatesn',
                              s.id
                            ]"
                            >voir plus
                          </a>
                        </div>
                      </div>

                      <!--end::Card body-->
                    </div>
                    <!--end::Card-->
                  </div>
                  <!--end::Col-->

                  <div
                  class="pagination"
                  *ngIf="listconsulatant && listconsulatant.length"
                >
                  <app-pagination
                    [data]="listconsulatant"
                    [lengthData]="totalItems"
                    [currentPageList]="currentPage"
                    (setPages)="getItems($event)"
                  >
                  </app-pagination>
                </div>
    
                <div
                  class="alert alert-warning text-center mt-5"
                  role="alert"
                  *ngIf="!listconsulatant.length && !loadSpinnerTable"
                >
                  <img src="/assets/media/errors/no-data.png" alt="" class="mb-5" />
                  <span class="empty-list"> La liste est vide </span>
                </div>
                </div>
                <!--end::Row-->
              </div>
              <!--end::Tab pane-->
              <!--begin::Tab pane-->
              <div
                id="kt_project_targets_table_pane"
                class="tab-pane fade show active"
              >
                <div class="content">
                  <div class="card-body pt-3">
                    <!--begin::Table-->
                    <!--begin::Table-->
                    <div class="table-responsive"  id="kt_customers_table">
                      <table
                        class="table align-middle gy-5 "
                       
                      >
                        <thead>
                          <tr
                            class="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0"
                          >
                            <ng-container
                              *ngFor="let item of listNames; let i = index"
                            >
                              <th
                                class="min-w-175px"
                                [ngClass]="{ 'th-fixed': item === 'Nom' }"
                              >
                                <span>{{ item }}</span>
                                <i
                                  *ngIf="
                                    ![
                                      'Image',
                                      'CV',
                                      'Dossier de compétence',
                                      'Score wegestu',
                                      'Réponses'
                                    ].includes(item)
                                  "
                                  (click)="sortData(item)"
                                  class="fa-solid fa-sort cursor-pointer"
                                ></i>
                              </th>
                            </ng-container>

                            <th class="min-w-125px"><span>Actions</span></th>

                            <th class="min-w-70px">
                              <div class="dropdown">
                                <button
                                  class="dropdown-toggle"
                                  type="button"
                                  id="dropdownMenuButton"
                                  data-bs-toggle="dropdown"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                  >
                                    <g filter="url(#filter0_d_588_1699)">
                                      <rect
                                        x="4"
                                        width="20"
                                        height="20"
                                        rx="4"
                                        fill="#63C3E8"
                                        fill-opacity="0.12"
                                        shape-rendering="crispEdges"
                                      />
                                    </g>
                                    <path
                                      d="M17.5 10.6H14.6V13.5C14.6 13.8314 14.3314 14.1 14 14.1C13.6686 14.1 13.4 13.8314 13.4 13.5V10.6H10.5C10.1686 10.6 9.9 10.3314 9.9 10C9.9 9.66863 10.1686 9.4 10.5 9.4H13.4V6.5C13.4 6.16863 13.6686 5.9 14 5.9C14.3314 5.9 14.6 6.16863 14.6 6.5V9.4H17.5C17.8314 9.4 18.1 9.66863 18.1 10C18.1 10.3314 17.8314 10.6 17.5 10.6Z"
                                      fill="#265D91"
                                      stroke="#265D91"
                                      stroke-width="0.2"
                                    />
                                    <defs>
                                      <filter
                                        id="filter0_d_588_1699"
                                        x="0"
                                        y="0"
                                        width="28"
                                        height="28"
                                        filterUnits="userSpaceOnUse"
                                        color-interpolation-filters="sRGB"
                                      >
                                        <feFlood
                                          flood-opacity="0"
                                          result="BackgroundImageFix"
                                        />
                                        <feColorMatrix
                                          in="SourceAlpha"
                                          type="matrix"
                                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                          result="hardAlpha"
                                        />
                                        <feOffset dy="4" />
                                        <feGaussianBlur stdDeviation="2" />
                                        <feComposite
                                          in2="hardAlpha"
                                          operator="out"
                                        />
                                        <feColorMatrix
                                          type="matrix"
                                          values="0 0 0 0 0.14902 0 0 0 0 0.364706 0 0 0 0 0.568627 0 0 0 0.13 0"
                                        />
                                        <feBlend
                                          mode="normal"
                                          in2="BackgroundImageFix"
                                          result="effect1_dropShadow_588_1699"
                                        />
                                        <feBlend
                                          mode="normal"
                                          in="SourceGraphic"
                                          in2="effect1_dropShadow_588_1699"
                                          result="shape"
                                        />
                                      </filter>
                                    </defs>
                                  </svg>
                                </button>
                               <div class="dropdown-table">
                                <div
                                class="dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <div
                                  class="d-flex checkbox mb-2 menu"
                                  *ngFor="
                                    let item of dataHeader;
                                    let i = index
                                  "
                                >
                                  <div
                                    class="form-check form-check-sm form-check-custom form-check-solid"
                                    *ngIf="item.name != 'checkbox'"
                                  >
                                    <input
                                      class="form-check-input checkbox-border"
                                      [checked]="
                                        (item.checked == 'oui' &&
                                          !item.checked_user) ||
                                        (item.checked_user == 'oui' &&
                                          (item.checked == 'non' ||
                                            item.checked == 'oui'))
                                      "
                                      (change)="
                                        changeSelectionElement(
                                          $event,
                                          item,
                                          i
                                        )
                                      "
                                      type="checkbox"
                                      value="1" [disabled]="item.name==='Image' || item.name==='Nom'"
                                    />
                                    <a class="dropdown-item">{{
                                      item.name
                                    }}</a>
                                  </div>
                                </div>
                              </div>
                               </div>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody class="fw-semibold text-gray-600">
                          <tr
                            *ngFor="
                              let consultant of listconsulatant;
                              let i = index
                            "
                          >
                            <td *ngIf="listNames.includes('Image')">
                              <img
                                *ngIf="
                                  consultant.image_url &&
                                  consultant.image_url != 'avatar.png'
                                "
                                class="table-img circle-img"
                                src="{{ urlimage + consultant.image_url }}"
                                alt=""
                                width="50px"
                              />
                              <img
                                *ngIf="
                                  consultant.image_url &&
                                  consultant.image_url == 'avatar.png'
                                "
                                class="table-img circle-img"
                                src="{{
                                  url +
                                    '/Company/file/gallery_company/avatar.png'
                                }}"
                                alt=""
                                width="50px"
                              />
                              <img
                                *ngIf="
                                  !consultant.image_url ||
                                  consultant.image_url === 'undefined'
                                "
                                class="table-img circle-img"
                                src="{{
                                  url +
                                    '/Company/file/gallery_company/avatar.png'
                                }}"
                                alt=""
                                width="50px"
                              />
                            </td>
                            <td *ngIf="listNames.includes('Nom')" class="td-fixed">
                              <a
                                class="first-td"
                                [routerLink]="[
                                  '/candidats/profilecandidatesn',
                                  consultant.id
                                ]"
                              >
                              {{ consultant.first_name }}
                                {{ consultant.last_name }}
                               
                              </a>
                            </td>
                            <td *ngIf="listNames.includes('ESN')">
                              <span>{{
                                consultant.ESN2 ? consultant.ESN2 : "---"
                              }}</span>
                            </td>
                            <td *ngIf="listNames.includes('Poste')">
                              <span *ngIf="consultant.poste && consultant.poste !=='null'  && consultant.poste !==null">{{ consultant.poste  }}</span>
                              <span  *ngIf="!consultant.poste || consultant.poste==null || consultant.poste==='null'">---</span> 
                            </td>
                            <td *ngIf="listNames.includes('Projet')">
                              <span>{{
                                consultant.project_names
                                  ? consultant.project_names
                                  : "---"
                              }}</span>
                            </td>

                            <td *ngIf="listNames.includes('Expérience')">
                              <span
                                class="experience"
                                *ngIf="
                                  consultant.years_of_experience !== '0 ans'
                                "
                              >
                                {{
                                  consultant.years_of_experience
                                    ? consultant.years_of_experience + " "
                                    : "---"
                                }}
                              </span>
                              <span
                                class="experience"
                                *ngIf="
                                  consultant.years_of_experience === '0 ans'
                                "
                                >---</span
                              >
                            </td>
                            <td *ngIf="listNames.includes('TJM(Achat)')">
                              <span class="experience">
                                {{
                                  consultant.Tjm_achat
                                    ? consultant.Tjm_achat +
                                      "
                                                                "
                                    : "---"
                                }}
                              </span>
                              <!-- <span *ngIf="consultant.Tjm_achat === '0'"
                                >---</span
                              > -->
                            </td>
                            <td *ngIf="listNames.includes('N°Tel')">
                              <span>{{
                                consultant.phone_number !== undefined &&
                                consultant.phone_number !== null &&
                                consultant.phone_number !== "undefined"
                                  ? consultant.phone_number
                                  : "---"
                              }}</span>
                            </td>

                            <td *ngIf="listNames.includes('Email Personnel')">
                              <span>
                                {{
                                  consultant.email
                                    ? consultant.email + " "
                                    : "---"
                                }}
                              </span>
                            </td>

                            <td
                              *ngIf="listNames.includes('Email Professionnel')"
                            >
                              <span
                                >{{
                                  consultant.emailProClient
                                    ? consultant.emailProClient +
                                      "
                                                                "
                                    : "---"
                                }}
                              </span>
                            </td>
                            <td *ngIf="listNames.includes('CV')">
                              <a
                                *ngIf="consultant.cv"
                                class="file-cursor"
                                style="cursor: pointer"
                                (click)="downloadFiles('single', consultant)"
                                ><svg
                                  width="26"
                                  height="26"
                                  viewBox="0 0 26 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M25.4273 4.11964V21.4987C25.4273 22.575 24.9783 23.6084 24.1801 24.3693C23.382 25.1302 22.2981 25.5583 21.1692 25.5583H4.25806C3.12915 25.5583 2.04528 25.1302 1.24716 24.3693C0.449034 23.6084 0 22.575 0 21.4987V4.11964C0 3.04334 0.449034 2.01001 1.24716 1.24908C2.04528 0.488163 3.12915 0.0600586 4.25806 0.0600586H21.1692C22.2981 0.0600586 23.382 0.488163 24.1801 1.24908C24.9783 2.01001 25.4273 3.04334 25.4273 4.11964ZM11.7058 19.8279C12.1182 20.197 12.7193 20.2896 13.2288 20.0802C13.3766 20.0185 13.5118 19.9339 13.6314 19.8279L17.8543 16.0528C18.4216 15.5469 18.4497 14.696 17.919 14.1566C17.387 13.6157 16.4959 13.5875 15.9287 14.0948L14.0762 15.7509V6.77012C14.0762 6.02933 13.4456 5.42811 12.6686 5.42811C11.8916 5.42811 11.261 6.02933 11.261 6.77012V15.7509L9.40855 14.0948C8.84127 13.5875 7.95025 13.6157 7.41817 14.1566C6.88749 14.696 6.91565 15.5469 7.48292 16.0528L11.7058 19.8279Z"
                                    fill="#F58F29"
                                  />
                                </svg>
                              </a>
                              <span *ngIf="!consultant.cv">---</span>
                            </td>
                            <td
                              *ngIf="
                                listNames.includes('Dossier de compétence')
                              "
                            >
                              <a
                                *ngIf="consultant.cv_wegestu"
                                class="file-cursor"
                                style="cursor: pointer"
                                (click)="downloadFiles('single', consultant)"
                                ><svg
                                  width="26"
                                  height="26"
                                  viewBox="0 0 26 26"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M25.4273 4.11964V21.4987C25.4273 22.575 24.9783 23.6084 24.1801 24.3693C23.382 25.1302 22.2981 25.5583 21.1692 25.5583H4.25806C3.12915 25.5583 2.04528 25.1302 1.24716 24.3693C0.449034 23.6084 0 22.575 0 21.4987V4.11964C0 3.04334 0.449034 2.01001 1.24716 1.24908C2.04528 0.488163 3.12915 0.0600586 4.25806 0.0600586H21.1692C22.2981 0.0600586 23.382 0.488163 24.1801 1.24908C24.9783 2.01001 25.4273 3.04334 25.4273 4.11964ZM11.7058 19.8279C12.1182 20.197 12.7193 20.2896 13.2288 20.0802C13.3766 20.0185 13.5118 19.9339 13.6314 19.8279L17.8543 16.0528C18.4216 15.5469 18.4497 14.696 17.919 14.1566C17.387 13.6157 16.4959 13.5875 15.9287 14.0948L14.0762 15.7509V6.77012C14.0762 6.02933 13.4456 5.42811 12.6686 5.42811C11.8916 5.42811 11.261 6.02933 11.261 6.77012V15.7509L9.40855 14.0948C8.84127 13.5875 7.95025 13.6157 7.41817 14.1566C6.88749 14.696 6.91565 15.5469 7.48292 16.0528L11.7058 19.8279Z"
                                    fill="#F58F29"
                                  />
                                </svg>
                              </a>
                              <span *ngIf="!consultant.cv_wegestu">---</span>
                            </td>
                            <td
                              *ngIf="listNames.includes('Dernière connexion')"
                            >
                              <span>
                                {{
                                  !consultant.last_connection
                                    ? "---"
                                    : consultant.last_connection
                                        .split(
                                          "
                                                            "
                                        )[0]
                                        .split("-")
                                        .reverse()
                                        .join("/")
                                }}
                              </span>
                            </td>
                            <td class="actions">
                              <div class="tools">
                                <div class="dropdown">
                                  <button
                                    class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                                    type="button"
                                    id="dropdownMenuButton"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                  >
                                    <svg
                                      width="19"
                                      height="5"
                                      viewBox="0 0 19 5"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <circle
                                        cx="2.44739"
                                        cy="2.44739"
                                        r="2.44739"
                                        transform="matrix(1 0 0 -1 0 4.89478)"
                                        fill="#265D91"
                                      />
                                      <circle
                                        cx="2.44739"
                                        cy="2.44739"
                                        r="2.44739"
                                        transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                        fill="#265D91"
                                      />
                                      <circle
                                        cx="2.44739"
                                        cy="2.44739"
                                        r="2.44739"
                                        transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                        fill="#265D91"
                                      />
                                    </svg>
                                  </button>
                                  <div
                                    class="dropdown-menu"
                                    aria-labelledby="dropdownMenuButton"
                                  >
                                    <a
                                      class="dropdown-item"
                                      [routerLink]="[
                                      '/candidats/profilecandidatesn',
                                      consultant.id
                                    ]"
                                      style="cursor: pointer"
                                      >Voir Détail</a
                                    >

                                    <a
                                      class="dropdown-item"
                                      (click)="
                                        openModal(
                                          modifier_consultant,
                                          consultant
                                        )
                                      "
                                      style="cursor: pointer"
                                    >
                                      Modifier
                                    </a>
                                    <a
                                      class="dropdown-item cursor-pointer"
                                      (click)="
                                        dissocierconsultant(consultant.id)
                                      "
                                      >Dissocier consultant</a
                                    >
                                  </div>
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!--end::Table-->

                    <div
                    class="pagination"
                    *ngIf="listconsulatant && listconsulatant.length"
                  >
                    <app-pagination
                      [data]="listconsulatant"
                      [lengthData]="totalItems"
                      [currentPageList]="currentPage"
                      (setPages)="getItems($event)"
                    >
                    </app-pagination>
                  </div>
      
                  <div
                    class="alert alert-warning text-center mt-5"
                    role="alert"
                    *ngIf="!listconsulatant.length && !loadSpinnerTable"
                  >
                    <img src="/assets/media/errors/no-data.png" alt="" class="mb-5" />
                    <span class="empty-list"> La liste est vide </span>
                  </div>
                  </div>
                </div>
              </div>
              <!--end::Tab pane-->
            </div>

            <div class="tab-content for-mobile">
              <!--begin::Tab pane-->
              <div
                id="kt_project_targets_card_pane"
                class="tab-pane fade show active"
              >
                <!--begin::Row-->
                <div class="row g-6 g-xl-9 justify-content-center">
                  <!--begin::Col-->
                  <div
                    class="col-md-6 col-xxl-4"
                    *ngFor="let s of listconsulatant"
                  >
                    <!--begin::Card-->
                    <div class="card pt-5 p-5">
                      <div class="tools">
                        <div class="dropdown">
                          <button
                            class="btn btn-sm btn-light btn-flex btn-center btn-active-light-primary dropdown-toggle"
                            type="button"
                            id="dropdownMenuButton"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            <svg
                              width="19"
                              height="5"
                              viewBox="0 0 19 5"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 0 4.89478)"
                                fill="#265D91"
                              />
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 6.85254 4.89478)"
                                fill="#265D91"
                              />
                              <circle
                                cx="2.44739"
                                cy="2.44739"
                                r="2.44739"
                                transform="matrix(1 0 0 -1 13.7061 4.89478)"
                                fill="#265D91"
                              />
                            </svg>
                          </button>
                          <div
                            class="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            <a
                              class="dropdown-item"
                              [routerLink]="[
                              '/candidats/profilecandidatesn',
                              s.id
                            ]"
                              style="cursor: pointer"
                              >Voir Détail</a
                            >

                            <a
                              class="dropdown-item"
                              (click)="openModal(modifier_consultant, s)"
                              style="cursor: pointer"
                            >
                              Modifier
                            </a>
                          </div>
                        </div>
                      </div>
                      <!--begin::Card body-->

                      <div class="card-body d-flex flex-center flex-column">
                        <div class="symbol symbol-65px symbol-circle mb-5">
                          <!-- <img src="assets/media//avatars/300-2.jpg" alt="image" /> -->

                          <img
                            class="table-img"
                            src="/assets/media/avatar.png"
                            alt=""
                            width="50px"
                          />

                          
                        </div>
                        <!--end::Avatar-->
                        <!--begin::Name-->
                        <a class="fs-4 text-gray-800 fw-bold mb-0"
                          >{{ s.first_name }} {{ s.last_name }}</a
                        >

                        <div class="content-card">
                          <!--begin::Stats-->
                          <div class="info">
                            <div class="py-3 px-4">
                              <div class="badge-annee">
                                <span>Date :</span>
                                {{
                                  s.consultant_client_finals_date_first_service
                                    ? s.consultant_client_finals_date_first_service
                                    : "---"
                                }}
                              </div>
                            </div>
                          </div>

                          <!--end::Stats-->
                          <!--begin::Stats-->

                          <!--end::Stats-->
                        </div>

                        <!--end::Info-->
                      </div>
                      <div class="foot p-5">
                        <div class="plus">
                          <a
                            style="cursor: pointer"
                            [routerLink]="[
                              '/profil-candidats-anonyme',
                              s.id
                            ]"
                            >voir plus
                          </a>
                        </div>
                      </div>

                      <!--end::Card body-->
                    </div>
                    <!--end::Card-->
                  </div>
                  <!--end::Col-->

                  <div
                  class="pagination"
                  *ngIf="listconsulatant && listconsulatant.length"
                >
                  <app-pagination
                    [data]="listconsulatant"
                    [lengthData]="totalItems"
                    [currentPageList]="currentPage"
                    (setPages)="getItems($event)"
                  >
                  </app-pagination>
                </div>
    
                <div
                  class="alert alert-warning text-center mt-5"
                  role="alert"
                  *ngIf="!listconsulatant.length && !loadSpinnerTable"
                >
                  <img src="/assets/media/errors/no-data.png" alt="" class="mb-5" />
                  <span class="empty-list"> La liste est vide </span>
                </div>
                </div>
                <!--end::Row-->
              </div>
              <!--end::Tab pane-->
              <!--begin::Tab pane-->
             
              <!--end::Tab pane-->
            </div>
          

            <!--end::Table-->
          </div>
          <!--end::Card body-->
        </div>
        <!--end::Card-->
        <!--begin::Modals-->
        <!--begin::Modal - Customers - Add-->

        <!--end::Modal - Customers - Add-->
        <!--begin::Modal - Adjust Balance-->

        <!--end::Modal - New Card-->
        <!--end::Modals-->
      </div>
      <!--end::Content container-->
    </div>
    <!--end::Content wrapper-->
    <!--begin::Footer-->

    <!--end::Footer-->
    <!--end:::Main-->
  </div>
  <ng-template #add_consultant>
    <div
      class="modal-dialog-centered"
      id="add_consultant"
      tabindex="-1"
      aria-hidden="true"
    >
      <!--begin::Modal dialog-->
      <!--begin::Modal content-->
      <div class="modal-content pt-5 pb-15">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="fw-bold">Ajouter consultant externe</h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <div
            id="kt_customers_export_close"
            class="btn btn-icon btn-sm btn-active-icon-primary"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
          <!--end::Close-->
        </div>

        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div
          class="modal-body text-center mx-5 mx-xl-15 my-7"
          [formGroup]="ConsultForm"
        >
          <!--begin::Form-->
          <div class="card-body">
            <div class="flex_input mb-3">
              <label for="web" class="required"> Email Personnel</label>
              <input
                type="text"
                (change)="getconsultantByEmail($event)" 
                formControlName="email"
                name="email_consultant"
                id="nom_consultant"
                class="form-control form-control-solid mb-3"
                placeholder="Email "
              />
              <app-feild-error
                [control]="ConsultForm.get('email')"
                [controlName]="'email'"
              ></app-feild-error>
            </div>
            <div class="flex_input mb-3">
              <label for="web" class="required">Nom </label>
              <input
                type="text"
                formControlName="last_name"
                name="last_name"
                id="nom_consultant"
                class="form-control form-control-solid mb-3"
                placeholder="Nom "
              />
              <app-feild-error
                [control]="ConsultForm.get('last_name')"
                [controlName]="'last_name'"
              ></app-feild-error>
            </div>
            <div class="flex_input mb-3">
              <label for="web" class="required">Prénom </label>
              <input
                type="text"
                formControlName="first_name"
                name="first_name"
                id="nom_consultant"
                class="form-control form-control-solid mb-3"
                placeholder="Prénom "
              />
              <app-feild-error
                [control]="ConsultForm.get('first_name')"
                [controlName]="'first_name'"
              ></app-feild-error>
            </div>
            <div class="flex_input mb-3">
              <label for="web"> Email Professionnel</label>
              <input
                type="text"
                formControlName="emailProClient"
                name="email_consultant"
                id="nom_consultant"
                class="form-control form-control-solid mb-3"
                placeholder="Email "
              />
              <app-feild-error
                [control]="ConsultForm.get('emailProClient')"
                [controlName]="'emailProClient'"
              ></app-feild-error>
            </div>

            <div class="flex_input mb-3">
              <label for="web"> LinkedIn</label>
              <input
                type="text"
                name="linkedin"
                id="linkedin"
                class="form-control form-control-solid mb-3"
                placeholder="https://www.linkedin.com/in/"
                formControlName="linkedin_link"
                (input)="setValidatorRequirements()"
              />
              <div
                *ngIf="
                  ConsultForm.get('linkedin_link')?.hasError('required') &&
                  ConsultForm.get('linkedin_link')?.touched
                "
                class="text-danger"
              >
                Le champ "linkedin" est obligatoire.
              </div>
              <div
                *ngIf="
                  ConsultForm.get('linkedin_link')?.hasError('pattern') &&
                  ConsultForm.get('linkedin_link')?.touched
                "
                class="text-danger"
              >
                Entrer une URL valide exemple:
                https://www.linkedin.com/in/exemple
              </div>
            </div>
            <div class="flex_input mb-3">
              <div class="flex_input">
                <div class="">
                  <div class="labels">
                    <label *ngIf="!selectedconsultant" for="cv"
                      >Importer CV (Le cv doit être (.pdf /.docx))</label
                    >
                    <span *ngIf="selectedconsultant">
                      <label for="cv">CV</label>
                    </span>
                    &nbsp;&nbsp;
                    <span  *ngIf="selectedconsultant!== 'null'"><strong>{{ selectedconsultant }}</strong></span>
                    <a class="cv"></a>
                    <button
                      *ngIf="showResetButtons && fileName !== '' && !iscv"
                      class="more-label"
                      (click)="resetCV()"
                    >
                      <img
                        src="assets/media/icons/icon-delete.png"
                        alt=""
                        width="30px"
                        class="cursor-pointer"
                      />
                    </button>
                  </div>
                </div>
                <input *ngIf="!iscv"

                  id="fileInput"
                  #inputFile
                  type="file"
                  name="cv"
                  id="cv"
                  (change)="uploadFile($event); setValidatorRequirements()"
                  class="form-control mb-3" [disabled]="isexistemail"
                />
                <input *ngIf="iscv" type="text" name="cv" id="cv" formControlName="cv"
                class="form-control mb-3" placeholder="cv" [readonly]="true" />
                <span style="color: red" *ngIf="fileError"
                  ><small>{{ fileError }}</small></span
                >
                <span style="color: red" *ngIf="fileExtention"
                  ><small>{{ fileExtention }}</small></span
                >
               
              </div>
            </div>

            <div class="requirem">
              <span class="requirements mt-5">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_379_198)">
                    <path
                      d="M8 16C9.58225 16 11.129 15.5308 12.4446 14.6518C13.7602 13.7727 14.7855 12.5233 15.391 11.0615C15.9965 9.59966 16.155 7.99113 15.8463 6.43928C15.5376 4.88743 14.7757 3.46197 13.6569 2.34315C12.538 1.22433 11.1126 0.462403 9.56072 0.153721C8.00887 -0.15496 6.40034 0.00346629 4.93853 0.608967C3.47672 1.21447 2.22729 2.23985 1.34824 3.55544C0.469192 4.87104 0 6.41775 0 8C0.00229405 10.121 0.845886 12.1545 2.34568 13.6543C3.84547 15.1541 5.87897 15.9977 8 16ZM8 3.33334C8.19778 3.33334 8.39112 3.39199 8.55557 3.50187C8.72002 3.61175 8.84819 3.76793 8.92388 3.95065C8.99957 4.13338 9.01937 4.33445 8.98079 4.52843C8.9422 4.72241 8.84696 4.90059 8.70711 5.04044C8.56726 5.1803 8.38907 5.27554 8.19509 5.31412C8.00111 5.35271 7.80004 5.3329 7.61732 5.25722C7.43459 5.18153 7.27841 5.05336 7.16853 4.88891C7.05865 4.72446 7 4.53112 7 4.33334C7 4.06812 7.10536 3.81377 7.29289 3.62623C7.48043 3.43869 7.73478 3.33334 8 3.33334ZM7.33333 6.66667H8C8.35362 6.66667 8.69276 6.80715 8.94281 7.0572C9.19286 7.30724 9.33333 7.64638 9.33333 8V12C9.33333 12.1768 9.2631 12.3464 9.13807 12.4714C9.01305 12.5964 8.84348 12.6667 8.66667 12.6667C8.48986 12.6667 8.32029 12.5964 8.19526 12.4714C8.07024 12.3464 8 12.1768 8 12V8H7.33333C7.15652 8 6.98695 7.92977 6.86193 7.80474C6.73691 7.67972 6.66667 7.51015 6.66667 7.33334C6.66667 7.15653 6.73691 6.98696 6.86193 6.86193C6.98695 6.73691 7.15652 6.66667 7.33333 6.66667Z"
                      fill="#2b5d8f"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_379_198">
                      <rect width="16" height="16" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                &nbsp;Au moins l'un des champs CV ou LinkedIn est requis.</span
              >
            </div>
            <div class="flex_input mb-3">
              <label for="web">Fournisseur </label>
              <ng-select
                class="index-select"
                formControlName="esn_id"
                [items]="esnList"
                bindLabel="name"
                bindValue="id"
                [placeholder]="'Esn'"
                autoComplete
                [notFoundText]="'Aucun élément trouvé'"
              >
              </ng-select>
            </div>

            <div class="flex_input mb-3">
              <label for="name">poste</label>
              <input
                type="text"
                formControlName="poste"
                id="desired_workstation"
                class="form-control mb-5"
                placeholder="poste"
              />
            </div>
            <div class="flex_input mb-3">
              <label for="début">Date de début Mission</label>
              <input
                type="date"
                id="debut"
                formControlName="date_first_mission"
                class="form-control mb-5"
              />
              <!-- <app-feild-error [control]="formconsultant.get('mission_start_date')" [controlName]="'mission_start_date'"></app-feild-error> -->
            </div>
            <div class="flex_input mb-3">
              <label for="fin">Date de fin Mission</label>
              <input
                type="date"
                id="debut"
                formControlName="date_end_mission"
                class="form-control mb-5"
              />
              <!-- <app-feild-error [control]="formconsultant.get('mission_end_date')" [controlName]="'mission_end_date'"></app-feild-error> -->
              <!-- Affichez le message d'erreur pour la plage de dates -->
              <!-- <div *ngIf="formconsultant.hasError('dateRangeInvalid')" style="color: red;">
                                       La date de début mission ne peut pas être supérieure à la date de fin mission.
                                       </div> -->
            </div>
            <div *ngIf="ConsultForm.hasError('dateRangeError')">
              <span class="text-danger">{{
                ConsultForm.getError("dateRangeError")
              }}</span>
            </div>

            <div class="flex_input mb-3">
              <label for="fin">TJM achat</label>
              <input
                oninput="validity.valid||(value='0');"
                min="0"
                [disabled]="true"
                formControlName="tjm_achat"
                type="number"
                name="tjm"
                id="tjm"
                class="form-control form-control-solid mb-3"
                placeholder="TJM achat"
              />
            </div>
            <div class="flex_input mb-3">
              <label for="fin">Projet</label>
              <ng-select
                [multiple]="true"
                [items]="listProjects"
                class="form-select"
                bindLabel="name"
                formControlName="project_ids"
                bindValue="id"
                [placeholder]="'Projet'"
                autoComplete
                [notFoundText]="'Aucun élément trouvé'"
              >
              </ng-select>
            </div>

            <!-- <div class="flex_input">
              <label for="fin"
                >Nombre de jours de prestation ( jusqu’au mois dernier)</label
              >

              <input
                (keypress)="keyPress($event)"
                formControlName="number_days_of_service"
                type="number"
                name="nbr_jr_prestation"
                id="nbr_jr_prestation"
                oninput="validity.valid||(value='0');"
                min="0"
                class="form-control form-control-solid mb-3"
                placeholder="Nombre de jours de prestation"
              />
            </div>
            <div class="flex_input">
              <label for="fin">Date de la première prestation</label>
              <input
                formControlName="date_first_service"
                type="date"
                name="Nom"
                id="Nom"
                class="form-control form-control-solid mb-3"
                placeholder="jj/mm/aaaa"
                
              />
            </div> -->
          </div>
          <!--end::Form-->
        </div>
        <div class="card-footer mx-5 mx-xl-15 my-7">
          <div class="actions">
            <a
              (click)="closeModal()"
              class="annuler cursor-pointer"
              aria-label="Close"
              >Annuler</a
            >
            <!-- <a class="confirmer cursor-pointer" (click)="addExternalConsult()">Confirmer</a> -->
            <button
              class="confirmer"
              [disabled]="
                fileError ||
                fileExtention ||
                ConsultForm.getError('dateRangeError')||(!ConsultForm.get('cv')?.value && !ConsultForm.get('linkedin_link')?.value && !isexistemail)|| (ConsultForm.get('cv')?.value === '' && ConsultForm.get('linkedin_link')?.value === '' && !isexistemail)" 
              (click)="addExternalConsult()">
              Confirmer
            </button>
          </div>
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal content-->
      <!--end::Modal dialog-->
    </div>
  </ng-template>
  <ng-template #modifier_consultant>
    <div
      class="modal-dialog-centered"
      id="modifier_consultant"
      tabindex="-1"
      aria-hidden="true"
    >
      <!--begin::Modal dialog-->
      <!--begin::Modal content-->
      <div class="modal-content pt-5 pb-15">
        <!--begin::Modal header-->
        <div class="modal-header">
          <!--begin::Modal title-->
          <h2 class="fw-bold">Modifier consultant externe</h2>
          <!--end::Modal title-->
          <!--begin::Close-->
          <div
            id="kt_customers_export_close"
            class="btn btn-icon btn-sm btn-active-icon-primary"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
          <!--end::Close-->
        </div>

        <!--end::Modal header-->
        <!--begin::Modal body-->
        <div
          class="modal-body text-center mx-5 mx-xl-15 my-7"
          [formGroup]="UpdateForm"
        >
          <!--begin::Form-->
          <div class="card-body">
           

            <div class="flex_input mb-3">
              <label for="web" class="required">Email Personnel </label>
              <input
                type="text"
                formControlName="email"
                name="ESN"
                id="nom_consultant"
                class="form-control form-control-solid mb-3"
                placeholder="email "
                [readonly]="true"
              />
            </div>
            <div class="flex_input mb-3">
              <label for="web"> Email Professionnel</label>
              <input
                type="text"
                formControlName="emailProClient"
                name="email_consultant"
                id="nom_consultant"
                class="form-control form-control-solid mb-3"
                placeholder="Email "
              />
              <div
                *ngIf="
                  UpdateForm.get('emailProClient')?.hasError('pattern') &&
                  UpdateForm.get('emailProClient')?.touched
                "
                class="text-danger"
              >
                La valeur de ce champ doit avoir une adresse email valide.
              </div>
            </div>
            <div class="flex_input mb-3">
              <label for="web" class="required">Nom </label>

              <input
                type="text"
                formControlName="first_name"
                name="nom_consultant"
                id="nom_consultant"
                class="form-control form-control-solid mb-3"
                placeholder="Nom et prenom"
                [readonly]="true"
              />
            </div>
            <div class="flex_input mb-3">
              <label for="web" class="required">Prénom </label>
              <input
                type="text"
                formControlName="last_name"
                name="nom_consultant"
                id="nom_consultant"
                class="form-control form-control-solid mb-3"
                placeholder="Nom et prenom"
                [readonly]="true"
              />
            </div>
            <div class="flex_input mb-3">
              <label for="web"> LinkedIn</label>
              <input
                type="text"
                formControlName="linkedin_link"
                id="web "
                class="form-control mb-5"
                placeholder="https://www.linkedin.com/in/votreprofil"
                [readonly]="true"
              />
              <!-- <app-feild-error [control]="formconsultant.get('linkedin_link')" [controlName]="'linkedin_link'"></app-feild-error> -->
            </div>

            <div class="flex_input mb-3">
              <label for="web"> CV</label>
              <input
                type="text"
                id="desired_workstation"
                formControlName="cv"
                class="form-control mb-5"
                placeholder="cv"
                [readonly]="true"
              />
            </div>
            <div class="flex_input mb-3">
              <label for="web">Fournisseur </label>
              <!-- <input
                type="text"
                id="desired_workstation"
                formControlName="esn_id"
                class="form-control mb-5"
                placeholder="ESN"
                [readonly]="true"
              /> -->
              <ng-select
              class="index-select"
              formControlName="esn_id"
              [items]="esnList"
              bindLabel="name"
              bindValue="id"
              [placeholder]="'Esn'"
              [notFoundText]="'Aucun élément trouvé'"
            >
            </ng-select>
            </div>

            <div class="flex_input mb-3">
              <label for="name">poste</label>
              <input
                type="text"
                formControlName="poste"
                id="desired_workstation"
                class="form-control mb-5"
                placeholder="poste"
              />
            </div>
            <div class="flex_input mb-3">
              <label for="début">Date de début Mission</label>
              <input
                type="date"
                id="debut"
                formControlName="date_first_mission"
                class="form-control mb-5"
              />
              <!-- <app-feild-error [control]="formconsultant.get('mission_start_date')" [controlName]="'mission_start_date'"></app-feild-error> -->
            </div>
            <div class="flex_input mb-3">
              <label for="fin">Date de fin Mission</label>
              <input
                type="date"
                id="debut"
                formControlName="date_end_mission"
                class="form-control mb-5"
              />
              <!-- <app-feild-error [control]="formconsultant.get('mission_end_date')" [controlName]="'mission_end_date'"></app-feild-error> -->
              <!-- Affichez le message d'erreur pour la plage de dates -->
              <!-- <div *ngIf="formconsultant.hasError('dateRangeInvalid')" style="color: red;">
                                       La date de début mission ne peut pas être supérieure à la date de fin mission.
                                       </div> -->
            </div>
            <div *ngIf="ConsultForm.hasError('dateRangeError')">
              <span class="text-danger">{{
                ConsultForm.getError("dateRangeError")
              }}</span>
            </div>

            <div class="flex_input">
              <label for="fin">TJM achat</label>
              <input
                [disabled]="true"
                formControlName="tjm_achat"
                type="number"
                name="tjm"
                id="tjm"
                oninput="validity.valid||(value='0');"
                min="0"
                class="form-control form-control-solid mb-3"
                placeholder="TJM achat"
              />
            </div>
            <div class="flex_input">
              <label for="fin">Projet</label>
              <ng-select
                [multiple]="true"
                [bindValue]="'id'"
                [items]="listProjects"
                formControlName="project_ids"
                [bindLabel]="'name'"
                id="compt"
                placeholder="Projet"
                [notFoundText]="'Aucun élément trouvé'"
              >
              </ng-select>
            </div>

            <!-- <div class="flex_input">
              <label for="fin">Nombre de jours de préstation</label>

              <input
                (keypress)="keyPress($event)"
                formControlName="number_days_of_service"
                type="number"
                oninput="validity.valid||(value='0');"
                min="0"
                name="nbr_jr_prestation"
                id="nbr_jr_prestation"
                class="form-control form-control-solid mb-3"
                placeholder="Nombre de jours de prestation"
              />
            </div>
            <div class="flex_input">
              <label for="fin">Date de première préstation</label>
              <input
                formControlName="date_first_service"
                type="date"
                name="Nom"
                id="Nom"
                class="form-control form-control-solid mb-3"
                placeholder="jj/mm/aaaa"
              />
            </div> -->
          </div>
          <!--end::Form-->
        </div>
        <div class="card-footer mx-5 mx-xl-15 my-7">
          <div class="actions">
            <a
              (click)="closeModal()"
              class="annuler cursor-pointer"
              aria-label="Close"
              >Annuler</a
            >
            <!-- <a class="confirmer cursor-pointer" (click)="updateconsultant()">Confirmer</a> -->
            <button
              class="confirmer cursor-pointer"
              [disabled]="UpdateForm.invalid"
              (click)="updateconsultant()"
            >
              Confirmer
            </button>
          </div>
        </div>
        <!--end::Modal body-->
      </div>
      <!--end::Modal content-->
      <!--end::Modal dialog-->
    </div>
  </ng-template>
  <ng-template #add_masse>
    <div class="modal-content" id="add_masse" tabindex="-1" aria-hidden="true">
      <!--begin::Modal dialog-->
      <!--begin::Modal content-->
      <div class="">
        <!--begin::Modal content-->
        <div class="content">
          <!--begin::Modal header-->
          <div class="modal-header">
            <!--begin::Modal title-->
            <h2 class="">Ajouter en masse</h2>
            <!--end::Modal title-->
            <!--begin::Close-->
            <div
              id="kt_customers_export_close"
              data-bs-dismiss="modal"
              class="btn btn-icon btn-sm btn-active-icon-primary"
            >
              <i class="ki-duotone ki-cross fs-1" (click)="closeModal()">
                <span class="path1"></span>
                <span class="path2"></span>
              </i>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <!--begin::Modal body-->
          <div class="modal-body scroll-y mx-5 mx-xl-15 my-7">
            <!--begin::Form (keyup.enter)="login()"-->
            <label for="masse">Votre ficher CSV</label>
            <input
              type="file"
              name="masse"
              id="masse"
              class="form-control"
              (change)="onFileSelected($event)"
            />

            <span style="color: red" *ngIf="fileExtentions"
              ><small>{{ fileExtentions }} </small></span
            >

            <div class="modal-footer">
              <button
                type="reset"
                (click)="closeModal()"
                id="kt_customers_export_cancel"
                data-bs-dismiss="modal"
                class="footer-btn annuler me-3"
              >
                Annuler
              </button>
              <button
                [disabled]="fileExtentions != '' || !selectedFile"
                type="submit"
                id="kt_customers_export_submit"
                (click)="addBulkCandidates()"
                class="footer-btn confirmer"
              >
                <span class="indicator-label">Confirmer</span>
                <span class="indicator-progress"
                  >Please wait...
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-2"
                  ></span
                ></span>
              </button>
            </div>
            <!--end::Form-->
          </div>
          <!--end::Modal body-->
        </div>
      </div>
    </div>
  </ng-template>
</div>
